import { ApplicationConfig } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { Routes } from '@angular/router';
import { UsersListComponent } from './user-list/user-list.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { TimerComponent } from './timer/timer.component';
import { UsersComponent } from './users/users.component';
import { GiveawayInfoComponent } from './giveaway-info/giveaway-info.component';
import { BubbleOverlayComponent } from './bubble-overlay/bubble-overlay.component';
import { TopExchangesComponent } from './top-exchanges/top-exchanges.component';
import { BannersOverlayComponent } from './banners-overlay/banners-overlay.component';
import { AnnouncementsOverlayComponent } from './announcements-overlay/announcements-overlay.component';
import { LatestEventOverlayComponent } from '../components/LatestEventOverlay/LatestEventOverlay.component';
import { NewYorkTimeComponent } from './clock/clock.component';
import { LatestNewsComponent } from './latest-news/latest-news.component';
import { NewYorkDateComponent } from './new-york-date/new-york-date.component';
import { PhpRedirectComponent } from './chat-overlay/php-redirect.component';
import { HorizontalMessagesComponent } from './combined-chat/combined-chat.component';
import { HorizontalMessages2Component } from './combined-chat2/combined-chat2.component';
import { WebCamComponent } from './webcam-overlay/webcam-overlay.component';
import { StreamEventOverlayComponent } from './stream-event/stream-event-overlay.component';
import { EventsListOverlayComponent } from './events-list-overlay/events-list-overlay.component';
import { LiveTradingBannersComponent } from './live-trading-banners/live-trading-banners.component';
import { CoinwiseEntriesComponent } from './coinwise-entries/coinwise-entries.component';

export const routes: Routes = [
  { path: 'public/overlay/giveaway-entries', component: UsersListComponent },
  { path: 'coinwise/public/overlay/giveaway-entries', component: CoinwiseEntriesComponent },
  { path: 'public/overlay/twitch-message', component: AlertDialogComponent},
  { path: 'public/overlay/timer', component: TimerComponent },
  { path: 'public/overlay/leaderboard', component: UsersComponent },
  { path: 'public/giveaway', component: GiveawayInfoComponent },
  { path: 'public/overlay/twitch-bubbles', component: BubbleOverlayComponent },
  { path: 'public/tools', component: TopExchangesComponent },
  { path: 'public/overlay/banners', component: BannersOverlayComponent },
  { path: 'public/overlay/announcements', component: AnnouncementsOverlayComponent },
  { path: 'public/overlay/latest-event', component: LatestEventOverlayComponent },
  { path: 'public/overlay/clock', component: NewYorkTimeComponent },
  { path: 'public/overlay/latestnews', component: LatestNewsComponent },
  { path: 'public/overlay/date', component: NewYorkDateComponent },
  { path: 'public/overlay/combined-chat', component: PhpRedirectComponent },
  { path: 'public/overlay/live-chat1', component: HorizontalMessagesComponent },
  { path: 'public/overlay/live-chat2', component: HorizontalMessages2Component },
  { path: 'public/overlay/3cam-view', component: WebCamComponent },
  { path: 'public/overlay/nearest-event', component: StreamEventOverlayComponent },
  { path: 'public/overlay/upcoming-events', component: EventsListOverlayComponent },
  { path: 'public/overlay/livetrading-banners', component: LiveTradingBannersComponent },
];
export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes)
  ]
};